import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { renderMarkdown } from '../lib/markdown';

const LegalPage = ({ title, eyebrow, content }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative overflow-hidden bg-black border-b border-neutral-900">
          <div
            aria-hidden
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                'radial-gradient(60% 50% at 20% 10%, rgba(59,130,246,0.18), transparent), radial-gradient(50% 50% at 90% 30%, rgba(255,255,255,0.04), transparent)',
            }}
          />
          <div className="relative max-w-[1100px] mx-auto px-6 lg:px-10 pt-16 pb-12">
            <nav className="flex items-center gap-1.5 text-[12.5px] text-neutral-500">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              <ChevronRight className="w-3.5 h-3.5" />
              <span className="text-neutral-300">{title}</span>
            </nav>
            <p className="mt-6 text-[13px] uppercase tracking-[0.18em] text-neutral-500">{eyebrow}</p>
            <h1 className="mt-3 text-[40px] sm:text-[52px] lg:text-[64px] leading-[1.02] tracking-[-0.025em] font-semibold text-white">
              {title}
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="bg-black">
          <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
            <div className="grid lg:grid-cols-12 gap-12">
              <aside className="hidden lg:block lg:col-span-3">
                <div className="sticky top-24">
                  <p className="text-[12px] uppercase tracking-wider text-neutral-500 mb-4">Legal</p>
                  <ul className="space-y-1">
                    {[
                      { label: 'Privacy', href: '/privacy' },
                      { label: 'Terms', href: '/terms' },
                      { label: 'Cookies', href: '/cookies' },
                      { label: 'Imprint', href: '/imprint' },
                    ].map((it) => {
                      const isActive = typeof window !== 'undefined' && window.location.pathname === it.href;
                      return (
                        <li key={it.href}>
                          <Link
                            to={it.href}
                            className={`block px-3 py-2 rounded-md text-[14px] transition-colors ${isActive ? 'bg-neutral-900 text-white' : 'text-neutral-400 hover:text-white hover:bg-neutral-900/60'}`}
                          >
                            {it.label}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </aside>
              <article className="lg:col-span-9 max-w-3xl">
                {renderMarkdown(content)}
              </article>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
